import React, { useState, useEffect, useCallback } from 'react'
import { appConstantSettings } from 'srcReact/appConstantSettings'
import Avatar from 'srcReact/components/common2/Avatar'
import styles from './styles.module.scss'
import { useDispatch, useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'
import { commonActions } from 'srcReact/components/actions'
import Popup from 'reactjs-popup'
import SelectNewsFeed from './components/SelectNewsFeed'
import MobileModal from '../MobileModal'
import ImagePicker from 'srcReact/MessengerPage/components/ImagePicker'
import ErrorMessage from '../ErrorMessage'
import { getProcessFiles } from 'srcReact/helpers/fileHelper'
import PostFeedModal from 'srcReact/components/popinsContent/PostFeedModal'
import { commonFeedActions } from '../FeedsTabContent/actions'
import { checkSharedText } from 'srcReact/helpers/utils'
import { htmlToText } from 'srcReact/helpers/utils'
import { sidebarActions } from 'srcReact/components/common2/Navigation/SideBarMain/action'

export default function NewFeed({ type, entity, isStatic }) {
  const urlParams = new URLSearchParams(window.location.search)

  const [clearContent, setClearContent] = useState(false)
  const [feedFileInputRef, setFeedFileInputRef] = useState(null)
  const [isFeedFile, setIsFeedFile] = useState(false)
  const [inputError, setInputError] = useState('')
  const [errorFromInputArea, setErrorFromInputArea] = useState('')
  const [showCreatePostPopup, setShowCreatePostPopup] = useState(false)
  const [showNewsFeedPopup, setShowNewsFeedPopup] = useState(false)
  const [content, setContent] = useState('')
  const dispatch = useDispatch()
  const [filesToUpload, setFilesToUpload] = useState([])
  const [finalFiles, setFinalFiles] = useState([])
  const [sharedText, setSharedText] = useState('')
  const [sharedTag, setSharedTag] = useState('')
  const [sharedImagesToUpload, setSharedImagesToUpload] = useState([])
  const [sharedImageDataUrls, setSharedImageDataUrls] = useState([])

  const {
    sideBar: { createPostPopup, newsFeedPopup },
    common: { isMobile, isTablet, isNative },
    commonNewsfeed: {
      draftMessages,
      createEditFeed,
      newsFeedId,
      newsFeedList: { groups, mixrs, selected }
    },
    login: { user: loggedInUser }
  } = useSelector((state) => state)
  const { t } = useTranslation()

  const getFileError = (fileError) => {
    setInputError(fileError)
  }

  useEffect(() => {
    /* If the URL parameter 'popup' is present it calls function 'openCreatePostPopup()' */
    if (urlParams.get('popup') || createPostPopup) {
      openCreatePostPopup()
    }
  }, [urlParams.get('popup'), createPostPopup])
  useEffect(() => {
    const sharedText = urlParams.get('sharedText')
    const sharedTag = urlParams.get('sharedTag')
    const sharedFiles = JSON.parse(urlParams.get('sharedFiles'))
    if (sharedText && sharedText.length > 0) {
      if (checkSharedText(sharedText)) {
        setSharedText(sharedText?.replace(/(https?:\/\/)/g, ' $1'))
      } else {
        setSharedText(sharedText)
      }
      setShowNewsFeedPopup(true)
    } else if (sharedFiles && sharedFiles.length > 0) {
      let updatedSharedFiles = []
      for (let i = 0; i < sharedFiles.length; i++) {
        fetch(sharedFiles[i].url)
          .then((response) => response.blob())
          .then((blob) => {
            const reader = new FileReader()
            reader.readAsDataURL(blob)
            reader.onloadend = () => {
              const base64Image = reader.result
              updatedSharedFiles.push(base64Image)
            }
          })
          .catch((error) => console.error('Error fetching shared image:', error))
      }
      setSharedImageDataUrls(updatedSharedFiles)
      setSharedImagesToUpload(sharedFiles)
      setSharedTag(sharedTag)
      setShowNewsFeedPopup(true)
    }
  }, [urlParams.get('sharedText'), urlParams.get('sharedFiles')])

  const closeCreatePostPopup = () => {
    dispatch(sidebarActions.setCreatePostPopup(false))
    setShowCreatePostPopup(false)
    resetShared()
    reset()
  }

  const resetShared = () => {
    setSharedImageDataUrls([])
    setSharedImagesToUpload([])
    setSharedTag('')
  }

  const reset = () => {
    setFilesToUpload([])
    setInputError('')
    setErrorFromInputArea('')
  }

  const openCreatePostPopup = () => {
    dispatch(sidebarActions.setCreatePostPopup(false))
    if (!isStatic) {
      if (type === 'feed') {
        handleShowNewsFeedPopup()
        return
      }
      setShowCreatePostPopup(true)
    }
  }

  const uploadImageCallBack = async (files) => {
    if (files.length > 0) {
      setShowCreatePostPopup(true)

      const filesLimit = appConstantSettings.FILES_LIMIT

      if (files.length <= filesLimit) {
        setFilesToUpload(files)
        setInputError('')
      } else {
        getFileError(t('messenger.clientErrors.maxFiles', { filesLimit }))
      }
    }
  }

  const handleGroupNewsFeedChange = (selectedFeed) => {
    let selectedGroupFeed = {
      id: selectedFeed.newsfeed_id,
      name: selectedFeed.group_title,
      picture: selectedFeed.group_picture,
      typeId: selectedFeed.group_id,
      type: selectedFeed.type
    }
    dispatch(commonFeedActions.setSelectedNewsFeed(selectedGroupFeed))
    setShowNewsFeedPopup(false)
    reset()
    if (isFeedFile) {
      feedFileInputRef.current.click()
    }
    setShowCreatePostPopup(true)
  }
  const handleMixrNewsFeedChange = (selectedFeed) => {
    let selectedMixrFeed = {
      id: selectedFeed.newsfeed_id,
      name: selectedFeed.mixr_title,
      picture: selectedFeed.mixr_picture,
      typeId: selectedFeed.mixr_id,
      type: selectedFeed.type
    }
    dispatch(commonFeedActions.setSelectedNewsFeed(selectedMixrFeed))
    setShowNewsFeedPopup(false)
    reset()
    if (isFeedFile) {
      feedFileInputRef.current.click()
    }
    setShowCreatePostPopup(true)
  }
  const handleShowNewsFeedPopup = (fileInputRef, isFile) => {
    if (isFile) {
      setIsFeedFile(isFile)
      setFeedFileInputRef(fileInputRef)
      setShowNewsFeedPopup(!showNewsFeedPopup)
      return
    }
    setIsFeedFile(false)
    setFeedFileInputRef(null)
    setShowNewsFeedPopup(!showNewsFeedPopup)
  }
  const closeNewsFeedPopup = () => {
    setShowNewsFeedPopup(false)
    reset()
  }

  const getDraftMessage = () => {
    let draftMessage = ''
    if (draftMessages && draftMessages[0]?.message?.length > 0 && draftMessages[0].message?.length > 0) {
      //  this message clears the styles and extract only text part to show the draft message in button
      draftMessage = htmlToText(draftMessages[0].message)
    } else {
      draftMessage = `${t('global.writePost')}...`
    }

    return draftMessage
  }
  return (
    <div className={styles.newPostContainer}>
      <div className={styles.textContainer}>
        <Avatar
          imgWrapperSize='small52'
          userId={loggedInUser?.id}
          profilePicture={loggedInUser?.profile_picture}
          firstname={loggedInUser?.firstname}
          lastname={loggedInUser?.lastname}
          mimeType={loggedInUser?.mime_type}
          originalTag={loggedInUser?.original_tag}
          isOriginal={loggedInUser?.is_original}
        />
        <button
          className={`${styles.btnShowCreatePostPopup} ${isStatic && styles.disabled}`}
          onClick={!isStatic && openCreatePostPopup}>
          <span className={styles.draftMessage} dangerouslySetInnerHTML={{ __html: getDraftMessage() }} />
        </button>
        {showCreatePostPopup && (
          <PostFeedModal
            newsfeedId={newsFeedId}
            isModalOpen={showCreatePostPopup}
            closeModal={closeCreatePostPopup}
            objectId={entity.id}
            objectName={entity.name}
            objectPicture={entity.picture}
            objectType={entity.type}
            objectGroupId={entity.groupId}
            existingFeed={{
              message:
                sharedText || (draftMessages && draftMessages[0]?.message?.length > 0 && draftMessages[0].message)
            }} //here the existing content can come from the draft
            originMessageId={createEditFeed.originMessageId}
            sharedImageDataUrls={sharedImageDataUrls}
            sharedImagesToUpload={sharedImagesToUpload}
            sharedTag={sharedTag}
            setSharedImageDataUrls={setSharedImageDataUrls}
            setSharedImagesToUpload={setSharedImagesToUpload}
            // sharedText={sharedText}
            // setSharedText={setSharedText}
            filesToUpload={filesToUpload}
            uploadImageCallBack={uploadImageCallBack}
            handleShowNewsFeedPopup={handleShowNewsFeedPopup}
            filesFromOuterSelection={filesToUpload}
            // sendMessage={sendMessage}
          />
        )}

        {isMobile ? (
          <MobileModal
            isOpen={showNewsFeedPopup}
            handleClose={closeNewsFeedPopup}
            className='selectNewsFeed'
            lockScroll
            customContentStyle={{
              height: isNative ? '95vh' : 'calc(100vh - 95px)'
            }}>
            <SelectNewsFeed
              closeModal={closeNewsFeedPopup}
              mixrFeeds={mixrs}
              groupFeeds={groups}
              handleGroupNewsFeedChange={handleGroupNewsFeedChange}
              handleMixrNewsFeedChange={handleMixrNewsFeedChange}
            />
          </MobileModal>
        ) : (
          <Popup
            open={showNewsFeedPopup}
            overlayStyle={{
              background: showCreatePostPopup ? 'transparent' : 'rgba(54, 73, 88, 0.4)',
              padding: '2rem 0'
            }}
            contentStyle={{
              width: '95%',
              height: '95%',
              maxWidth: '41.3rem',
              maxHeight: '31.5rem',
              padding: '1.5rem',
              borderRadius: '0.625rem',
              boxShadow: '5px 2px 10px 0 rgba(14, 11, 40, 0.15)',
              background: 'white',
              border: 'none',
              overflow: 'hidden'
            }}
            onClose={closeNewsFeedPopup}
            className='selectNewsFeed'
            closeOnDocumentClick={false}>
            <SelectNewsFeed
              closeModal={closeNewsFeedPopup}
              mixrFeeds={mixrs}
              groupFeeds={groups}
              handleGroupNewsFeedChange={handleGroupNewsFeedChange}
              handleMixrNewsFeedChange={handleMixrNewsFeedChange}
              mimeType={loggedInUser?.mime_type}
              originalTag={loggedInUser?.original_tag}
              isOriginal={loggedInUser?.is_original}
            />
          </Popup>
        )}
      </div>
      {!showCreatePostPopup && inputError && inputError.length > 0 && (
        <ErrorMessage text={inputError} className={styles.error} />
      )}
      {!isMobile && !isTablet && (
        <div className={styles.actionsContainer}>
          <ImagePicker
            type={type}
            handleShowNewsFeedPopup={!isStatic && handleShowNewsFeedPopup}
            uploadFileCallback={uploadImageCallBack}
            allowedImageTypes={appConstantSettings.ACCEPTED_IMAGE_TYPES}
            allowedImageSizeInMB={appConstantSettings.MAX_IMAGE_SIZE_MB}
            filesLimit={appConstantSettings.FILES_LIMIT}
            getFileError={getFileError}
            allowDocs={false}
            allowImages={true}
            iconText={t('createPost.picture')}
            isStatic={isStatic}
          />
          <ImagePicker
            type={type}
            handleShowNewsFeedPopup={!isStatic && handleShowNewsFeedPopup}
            uploadFileCallback={uploadImageCallBack}
            allowedDocumentTypes={appConstantSettings.ACCEPTED_DOCUMENT_TYPES}
            allowedDocumentSizeInMB={appConstantSettings.MAX_DOC_SIZE_MB}
            filesLimit={appConstantSettings.FILES_LIMIT}
            getFileError={getFileError}
            allowDocs={true}
            allowImages={false}
            iconText={t('global.document')}
            isStatic={isStatic}
          />
        </div>
      )}
    </div>
  )
}
